import { marked } from "marked";
import DOMPurify from "dompurify";

export function renderMarkdown(text: string): string {
    if (!text) { return ""; }
    const raw = marked.parse(text);
    return DOMPurify.sanitize(typeof raw === "string" ? raw : "");
}
